export const formProcessor = function (className) {
    // console.log("Hello");
    const form = document.getElementById(className);
    if (!form) return;

    const button = form.querySelector(".form__submit");
    const spinner = form.querySelector(".form__spinner");
    const successMsg = form.querySelector(".form__success");
    const errorMsg = form.querySelector(".form__error");
    const wrapper = form.querySelector(".form__wrapper");

    form.addEventListener("submit", (e) => {
        e.preventDefault();
        processForm();
    });

    const processForm = async function () {
        // Hide response (in case from previous form submit)
        successMsg.classList.add("display-none");
        errorMsg.classList.add("display-none");
        // Hide button and show spinner while form is being processed
        button.classList.add("display-none");
        spinner.classList.add("spinner-round--visible");

        //
        // console.log(button);
        // console.log(form.method);
        // console.log(document.querySelector('meta[name="csrf-token"]')["content"]);
        const rawResponse = await fetch(form.action, {
            headers: {
                "X-CSRF-TOKEN": document.querySelector(
                    'meta[name="csrf-token"]'
                )["content"],
            },
            method: form.method,
            body: new FormData(form),
        });
        const response = await rawResponse.json();
        console.log(response);
        if (response.success) {
            // Show success msg
            form.reset();
            successMsg.classList.remove("display-none");
            button.classList.remove("display-none");

            if (className != "formFooter") {
                wrapper.classList.add("display-none");
            }

            spinner.classList.remove("spinner-round--visible");
        } else {
            // Show error msg
            errorMsg.classList.remove("display-none");
            button.classList.remove("display-none");
            spinner.classList.remove("spinner-round--visible");
        }
    };
    return;
};
